export default "__VITE_ASSET__kulvkJ98__"